import React, {FC, useEffect, useState, useCallback} from 'react'

import {KTSVG} from '../../_metronic/helpers'
import axios from 'axios'
import {
  useTable,
 
  useSortBy,
 

} from 'react-table'
type Props = {

  adddatatable: any
  columnaddedtitems: any
 
}
const API_URL = process.env.REACT_APP_API_URL

const Mainsubtable2: React.FC<Props> = ({
  columnaddedtitems,
  adddatatable
}) => {
  
  const truncate = require('truncate')
  const [loadedProducts_unit, setLoadedProducts_unit] = useState(false)
  const [products_unit, setProducts_unit] = useState<any>([])
 
  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state} = useTable(
    {
      columns: columnaddedtitems as any,
      data: adddatatable,
  
      defaultColumn: {},
      initialState: {},
    },

    useSortBy
   
  )



  return (
    <>
         <table
                      {...getTableProps()}
                      className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                    >
                      <thead>
                        {headerGroups.map((headerGroup, keys) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()}
                            className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'
                            key={keys}
                          >
                            {headerGroup.headers.map((column, key) => (
                              <th
                                {...column.getHeaderProps(column.getSortByToggleProps())}
                                key={key}
                              >
                                {column.render('Header')}
                                <span>
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <>
                                        <span className='svg-icon svg-icon-primary svg-icon-1x'>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='24'
                                            height='24'
                                            viewBox='0 0 24 24'
                                          >
                                            <g fill='none' fillRule='evenodd'>
                                              <path d='M0 0L24 0 24 24 0 24z'></path>
                                              <path
                                                fill='#009ef7'
                                                fillRule='nonzero'
                                                d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                                              ></path>
                                            </g>
                                          </svg>
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className='svg-icon svg-icon-primary svg-icon-1x'>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='24'
                                            height='24'
                                            viewBox='0 0 24 24'
                                          >
                                            <g fill='none' fillRule='evenodd'>
                                              <path d='M0 0L24 0 24 24 0 24z'></path>
                                              <path
                                                fill='#009ef7'
                                                fillRule='nonzero'
                                                d='M6.707 15.707a1 1 0 11-1.414-1.414l6-6a1 1 0 011.383-.03l6 5.5a1 1 0 11-1.352 1.474l-5.294-4.853-5.323 5.323z'
                                              ></path>
                                            </g>
                                          </svg>
                                        </span>
                                      </>
                                    )
                                  ) : (
                                    ''
                                  )}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()} className='text-gray-600 fw-bold'>
                        {rows.length > 0 ? (
                          rows.map((row, morekeys) => {
                            prepareRow(row)
                            return (
                              <React.Fragment key={row.getRowProps().key}>
                                <tr {...row.getRowProps()} key={morekeys}>
                                  {row.cells.map((cell, key) => {
                                    return (
                                      
                                        <td {...cell.getCellProps()} key={key}>
                                          {cell.render('Cell')}
                                        </td>
                                     
                                    )
                                  })}
                                </tr>
                              </React.Fragment>
                            )
                          })
                        ) : (
                          <tr>
                            <td colSpan={columnaddedtitems.length}>
                              <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                              No Added Items
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
    </>
  )
}

export {Mainsubtable2}
